// extracted by mini-css-extract-plugin
export var bullet = "_mc-q";
export var bulletText = "_mc-p";
export var bullets = "_mc-k";
export var callout = "_mc-g";
export var calloutBody = "_mc-i";
export var calloutLabel = "_mc-h";
export var checkIcon = "_mc-m";
export var checkList = "_mc-j";
export var checkSvg = "_mc-n";
export var checkText = "_mc-o";
export var fieldCard = "_mc-1";
export var fieldDescription = "_mc-5";
export var fieldHeader = "_mc-3";
export var fieldTitle = "_mc-4";
export var finalNote = "_mc-s";
export var flow = "_mc-x";
export var flowArrow = "_mc-v";
export var flowStep = "_mc-u";
export var helperText = "_mc-r";
export var inlineTitle = "_mc-t";
export var listItem = "_mc-l";
export var noteBody = "_mc-8";
export var noteBodyText = "_mc-9";
export var noteCard = "_mc-2";
export var noteIcon = "_mc-6";
export var noteTitle = "_mc-7";
export var productChoices = "_mc-w";
export var radioDot = "_mc-d";
export var radioDotSelected = "_mc-e";
export var radioDotSvg = "_mc-f";
export var selectableCard = "_mc-b";
export var selectableCardSelected = "_mc-c";
export var strongText = "_mc-a";
export var subHeading = "_mc-0";